import {
  FilterInternalArgumentsBase,
  FilterHookArgumentsBase,
} from '@core/providers/filters'

export type BooleanFilterHookArguments = FilterHookArgumentsBase<boolean> & {
  placeholder?: string
}

export type BooleanFilterInternalArguments = BooleanFilterHookArguments &
  FilterInternalArgumentsBase<string, 'BOOLEAN'>

export const useBooleanFilter: (
  filter: BooleanFilterHookArguments,
) => BooleanFilterInternalArguments = (filter) => {
  const nothingSelectedText = filter.nothingSelectedText || filter.label

  const unfocusedText = () => filter.label

  return {
    type: 'BOOLEAN',
    unfocusedText,
    nothingSelectedText,
    serialization: 'string',
    ...filter,
  }
}
